import { useTranslation } from 'react-i18next';
import { Button } from '@cropler/ui-kit';

import stylesModal from '../../styles/modal.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const ProfileDeleteModal = ({ onDelete, onCancel }) => {
  const { t } = useTranslation();

  return (
    <>
      <p dangerouslySetInnerHTML={{ __html: t('profile.delete.modal.text1') }}></p>
      <p dangerouslySetInnerHTML={{ __html: t('profile.delete.modal.text2') }}></p>
      <div className={stylesModal.modalNav}>
        <Button type="danger" icon={<CroplerIcon name="remove" />} onClick={onDelete}>
          {t('actions.delete')}
        </Button>
        <Button type="secondary" onClick={onCancel}>
          {t('actions.cancel')}
        </Button>
      </div>
    </>
  );
};

export default ProfileDeleteModal;
